import { render, staticRenderFns } from "./NoBrand.vue?vue&type=template&id=1e6878cc&scoped=true&"
import script from "./NoBrand.vue?vue&type=script&lang=js&"
export * from "./NoBrand.vue?vue&type=script&lang=js&"
import style0 from "./NoBrand.vue?vue&type=style&index=0&id=1e6878cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6878cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6878cc')) {
      api.createRecord('1e6878cc', component.options)
    } else {
      api.reload('1e6878cc', component.options)
    }
    module.hot.accept("./NoBrand.vue?vue&type=template&id=1e6878cc&scoped=true&", function () {
      api.rerender('1e6878cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/brand/NoBrand.vue"
export default component.exports